(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller(
      'CashlessPaymentRefundController',
      cashlessPaymentRefundController
    );

  /** @ngInject */
  function cashlessPaymentRefundController(
    layoutActions,
    $scope,
    CashlessPaymentRefundViewModel,
    cashlessActions,
    $mdDialog,
    $translate,
    dispatcher,
    ActionTypesEnum
  ) {
    var vm = this;
    vm.cashlessPaymentRefundVM = new CashlessPaymentRefundViewModel();

    init();

    vm.pageChanged = function (page, limit) {
      vm.cashlessPaymentRefundVM.cashlessPaginationChanged(page, limit);
      refresh();
    };

    vm.sortChanged = function (order) {
      vm.cashlessPaymentRefundVM.cashlessOrderingChanged(order);
      refresh();
    };

    vm.searchCashlessPayments = function () {
      refresh();
    };

    vm.clearCashlessFilterInput = function () {
      vm.cashlessPaymentRefundVM.filter = '';
      refresh();
    };

    vm.refundPayment = function (ev, amount, paymentId) {
      var confirm = $mdDialog
        .prompt()
        .title($translate.instant('REFUND_DIALOG_TITLE'))
        .textContent($translate.instant('REFUND_DIALOG_SUBTITLE'))
        .placeholder($translate.instant('REFUND'))
        .ariaLabel($translate.instant('REFUND'))
        .initialValue(amount)
        .targetEvent(ev)
        .ok($translate.instant('REFUND'))
        .cancel($translate.instant('CANCEL'));

      $mdDialog.show(confirm).then(function (result) {
        if (result > amount || result < 0 || isNaN(result)) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant('INPUT_NOT_VALID')
            }
          });
          return;
        }
        cashlessActions
          .refundCashlessPayment(paymentId, result)
          .then(function () {
            refresh();
          });
      });
    };

    vm.exportToCsvReports = function () {
      layoutActions.showLoader();
      cashlessActions
        .getCashlessSalesExportCSV(
          vm.cashlessPaymentRefundVM.filter,
          vm.cashlessPaymentRefundVM.since.getTime(),
          vm.cashlessPaymentRefundVM.until.getTime()
        )
        .then(function (response) {
          var blob = new Blob([response], { type: 'text/csv;charset=utf-8;' });

          var url = URL.createObjectURL(blob);
          /* eslint-disable */
          var link = document.createElement('a');
          /* eslint-enable */
          link.href = url;
          link.download = 'Cashless_sales_report.csv';
          link.click();

          URL.revokeObjectURL(url);
          layoutActions.hideLoader();
        });
    };

    function refresh() {
      layoutActions.showLoader();
      cashlessActions
        .getCashlessSales(
          vm.cashlessPaymentRefundVM.filter,
          vm.cashlessPaymentRefundVM.since.getTime(),
          vm.cashlessPaymentRefundVM.until.getTime(),
          vm.cashlessPaymentRefundVM.page - 1,
          vm.cashlessPaymentRefundVM.pageSize,
          vm.cashlessPaymentRefundVM.orderBy,
          vm.cashlessPaymentRefundVM.order
        )
        .then(function (response) {
          cashlessActions
            .getCashlessTotals(
              vm.cashlessPaymentRefundVM.since.getTime(),
              vm.cashlessPaymentRefundVM.until.getTime(),
              vm.cashlessPaymentRefundVM.filter
            )
            .then(function (response) {
              vm.cashlessPaymentRefundVM.totalAmount = response.totalAmount;
              vm.cashlessPaymentRefundVM.totalNetAmount = response.totalNetAmount;
            });
          vm.cashlessPaymentRefundVM.refresh(response);
          layoutActions.hideLoader();
        });
    }

    function init() {
      $scope.$on('$destroy', destroy);
      refresh();
    }

    function destroy() {
      vm.cashlessPaymentRefundVM.destroy();
    }
  }
})();
